import React from "react";

const About = () => {
  return <div>ABOUT PAGE</div>;
};

export default About;
